import React from "react";
import { useState } from "react";
import config from "../../config/apiConfig";
import "./ForgotPassword.scss";

const ForgotPassword: React.FC = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const handleRequestReset = () => {
        const formData = new FormData();
        formData.append("token", config.token);
        formData.append("device", "web");
        formData.append("session-token", "AUTH");
        formData.append("email", email);
        const requestOptions: RequestInit = {
            body: formData,
            method: "POST",
        };
        fetch(
            config.BASE_URL + "/idam/user/request_password_reset",
            requestOptions
        )
            .then((res) => res.json())
            .then((res) =>
                setMessage(
                    res.is_error
                        ? res.error_msg
                        : "Check your email to reset password"
                )
            )
            .catch(() => setMessage("Some error occured"));
    };

    return (
        <div className="login">
            <div className="login__right">
                <div className="login__header">
                    <h2 style={{ fontSize: "26px" }}>Welcome to Pencil</h2>
                    <p>Password Reset</p>
                </div>
                <form className="login__form" id="form" method="post">
                    <label>
                        EMAIL
                        <input
                            type="text"
                            className="login__input"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </label>
                </form>
                <button className="login__button" onClick={handleRequestReset}>
                    Verify
                </button>
                <p className="login__error">{message}</p>
            </div>
        </div>
    );
};

export default ForgotPassword;
